import React from 'react';
import ReactJson from 'react-json-view';
import {Card, CardBody} from 'reactstrap';

const DebugApiResults = ({ lastCalledUrl, html, results }) => {
  const method = 'GET';
  
  const formatSelectors = (selectors) => {
    if (!selectors || selectors.length === 0) return null;
    
    return selectors.reduce((acc, selector) => {
      if (selector.name && selector.selector) {
        acc[selector.name] = {
          selector: selector.selector,
          type: selector.type || 'text',
          multiple: selector.multiple || false,
          ...(selector.type === 'attr' && selector.attr ? { attr: selector.attr } : {})
        };
      }
      return acc;
    }, {});
  };

  const getRequestBody = () => {
    return {
      site,
      selectors: formatSelectors(extractOptions.selectors),
      ai_query: extractOptions.aiQuery
    };
  };
  
  return (
    <div>
      <Card>
        <CardBody>
          <div className={'debugResultCardTitle flexSpaceBetween'}>
            <span className={'ogTextColor'}>Request</span>
          </div>
          <strong className={'blueText'}>{method}</strong>{` ${lastCalledUrl}`}
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <div className={'debugResultCardTitle flexSpaceBetween'}>
            <span className={'ogTextColor'}>Response</span>
          </div>
          {html ? (
            <pre>
              {results}
            </pre>
          ) : (
            <ReactJson 
              src={results} 
              theme={'summerfruit:inverted'} 
              classname={'breakWord'} 
              style={{wordBreak: 'break-word'}}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default DebugApiResults;
